import { Component } from '@angular/core';
import { companyInformation } from 'src/app/companyinformation';
import { SeoService } from '../../../../core/services/seo.service';
import { nav_path } from '../../../../app-routing.module';

@Component({
  selector: 'anon-answers-comments',
  templateUrl: './answers-comments.component.html',
  styleUrls: ['./answers-comments.component.scss']
})
export class AnswersCommentsComponent {
  public readonly companyInformation = companyInformation;
  private title = "Answers Comments page";

  constructor(private seo: SeoService) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.answersComments
    });
  }
}
